import { render } from "./scrollable-content.vue?vue&type=template&id=ef7789b8"
import script from "./scrollable-content.vue?vue&type=script&lang=js"
export * from "./scrollable-content.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__